import React, { useState } from 'react';
import {
  Button,
  Input,
  InputGroup,
  InputGroupText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import i18n from '@/utils/i18n';
import { FaPlus } from 'react-icons/fa';

type AddContainerStationModalProps = {
  onSubmit: (stationId: string) => void;
  onClose: () => void;
};

const AddContainerStationModal = ({
  onSubmit,
  onClose,
}: AddContainerStationModalProps) => {
  const [stationId, setStationId] = useState('');
  const [stationidError, setStationidError] = useState<string | undefined>();

  return (
    <>
      <Modal isOpen={true} toggle={() => onClose()}>
        <ModalHeader toggle={() => onClose()}>
          <p>{i18n.t('OrderFulfillment:addContainerStationModalTitle')}</p>
        </ModalHeader>

        <ModalBody>
          <p className="text-danger">{stationidError}</p>
          <InputGroup>
            <InputGroupText>
              {i18n.t('OrderFulfillment:containerStationId')}
            </InputGroupText>
            <Input
              type="text"
              invalid={stationId.length > 6}
              value={stationId}
              onChange={(e) => {
                let stationIdString = e.currentTarget.value;

                // in case someone inputs a container station name instead of id
                stationIdString = stationIdString.replace('cs_', '');

                if (stationIdString.length > 6) {
                  setStationidError(
                    i18n.t('OrderFulfillment:invalidContainerStationId'),
                  );
                } else {
                  if (!!stationidError?.length) {
                    setStationidError(undefined);
                  }
                }

                setStationId(stationIdString);
              }}
            />
          </InputGroup>
        </ModalBody>

        <ModalFooter>
          <Button
            color="primary"
            disabled={stationId.length > 6 || stationId.length === 0}
            onClick={() => {
              onSubmit(stationId);
              onClose();
            }}
          >
            <FaPlus /> {i18n.t('Common:add')}
          </Button>
          <Button onClick={() => onClose()} color="secondary">
            {i18n.t('Common:cancel')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AddContainerStationModal;
